export const separatorsForLocale = (locale) => {
    const cacheKey = locale.toLowerCase();
    if (separatorsForLocale.cache.has(cacheKey)) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return separatorsForLocale.cache.get(cacheKey);
    }
    const separators = Intl.NumberFormat(locale)
        .formatToParts(100000.001)
        .reduce((memo, { type, value }) => {
        switch (type) {
            case 'group':
            case 'decimal':
                memo[type] = value;
                break;
        }
        return memo;
    }, { group: ',', decimal: '.' });
    separatorsForLocale.cache.set(cacheKey, separators);
    return separators;
};
separatorsForLocale.cache = new Map();
